<template>
  <div>

    <!-- Blocked Domains Banner -->
    <BannerComponent>
      <button
          class="banner-toggle-btn"
          @click="toggleDropdown('blockedDomainsOpen')"
          :aria-expanded="blockedDomainsOpen"
      >
        <font-awesome-icon
            :icon="['fas', blockedDomainsOpen ? 'chevron-down' : 'chevron-right']"
        />
      </button>
      <h6 class="banner-heading">Blocked Domains</h6>
    </BannerComponent>

    <!-- Blocked Domains Section -->
    <div v-if="blockedDomainsOpen">

      <!-- Quick Block Items -->
      <div class="quick-block">
        <div class="body">Quick Block Items:</div>
        <div class="quick-block__items">
          <button
              v-for="item in quickBlocks"
              :key="item.domain"
              class="quick-block__btn cardBackground"
              @click="addQuickBlockDomain(item.domain)"
          >
            <font-awesome-icon :icon="[ item.prefix, item.icon ]" />
          </button>
        </div>
      </div>
      
      <!-- Add Domain button -->
      <div class="filterButtons">
        <div class="pageButton" @click="openAddDomainModal()">
          Add Domain
        </div>
      </div>

      <!-- Search & Filter -->
      <div class="search-bar" style="margin-top: 1.5rem;">
        <div class="search-input-wrapper">
          <font-awesome-icon :icon="['fas','magnifying-glass']" class="search-icon"/>
          <input
              type="text"
              v-model="domainSearchTerm"
              placeholder="Search Domains..."
              class="search-input cardBackground"
              @input="goToDomainsPage(1)"
          />
        </div>
<!--        <button class="filter-btn" @click="filterDomains">
          <font-awesome-icon :icon="['fas','filter']" />
        </button>-->
      </div>

      <!-- Blocked Sites List (paginated) -->
      <div class="list">
        <div
            v-for="domain in pagedDomains"
            :key="domain"
            class="list__item"
        >
          <span class="blocked-list__domain">{{ domain }}</span>
          <button
              class="blocked-list__remove-btn"
              @click="removeDomain(domain)"
          >
            <font-awesome-icon :icon="['fas','trash']" />
          </button>
        </div>
        <div v-if="filteredDomains.length === 0" class="no-results">
          No domains found
        </div>
      </div>

      <pagination-control
          :currentPage="currentDomainsPage"
          :pageCount="domainsPageCount"
          :maxVisible="3"
          @update:currentPage="goToDomainsPage"
      />

    </div>

    <!-- Blocked IPs Banner -->
    <BannerComponent>
      <button
          class="banner-toggle-btn"
          @click="toggleDropdown('blockedIPsOpen')"
          :aria-expanded="blockedIPsOpen"
      >
        <font-awesome-icon
            :icon="['fas', blockedIPsOpen ? 'chevron-down' : 'chevron-right']"
        />
      </button>
      <h6 class="banner-heading">Blocked IPs</h6>
    </BannerComponent>

    <!-- Blocked IPs Section -->
    <div v-if="blockedIPsOpen">

      <!-- Add Rule button -->
      <div class="filterButtons">
        <div class="pageButton" @click="openAddIPModal()">
          Add IP
        </div>
      </div>

      <!-- Search & Filter bar -->
      <div class="search-bar" style="margin-top: 1.5rem;">
        <div class="search-input-wrapper">
          <font-awesome-icon :icon="['fas','magnifying-glass']" class="search-icon"/>
          <input
              type="text"
              v-model="blockedIPsSearchTerm"
              placeholder="Search IP’s..."
              class="search-input cardBackground"
              @input="goToIPsPage(1)"
          />
        </div>
<!--        <button class="filter-btn" @click="filterIPs">
          <font-awesome-icon :icon="['fas','filter']" />
        </button>-->
      </div>

      <!-- IPs (paginated) -->
      <div class="list">
        <div
            v-for="address in pagedIPs"
            :key="address.ip"
            class="list__item"
        >
          <div v-if="address.description === ''">
            <span class="blocked-list__domain">{{ address.ip }}</span>
          </div>
          <div v-else>
            <span class="blocked-list__domain">{{ address.description }}</span>
          </div>
          <button
              class="blocked-list__remove-btn"
              @click="removeIP(address)"
          >
            <font-awesome-icon :icon="['fas','trash']" />
          </button>


        </div>
        <div v-if="filteredBlockedIPs.length === 0" class="no-results">
          No IPs found
        </div>
      </div>


      <pagination-control
          :currentPage="currentIPsPage"
          :pageCount="ipsPageCount"
          :maxVisible="3"
          @update:currentPage="goToIPsPage"
      />
    </div>

    <!-- Bulk Blocker Banner -->
    <BannerComponent>
      <button
          class="banner-toggle-btn"
          @click="toggleDropdown('bulkBlockerOpen')"
          :aria-expanded="bulkBlockerOpen"
      >
        <font-awesome-icon
            :icon="['fas', bulkBlockerOpen ? 'chevron-down' : 'chevron-right']"
        />
      </button>
      <h6 class="banner-heading">Bulk Blocker</h6>
    </BannerComponent>

    <div v-if="bulkBlockerOpen">
      <!-- Search & Filter bar -->
      <div class="search-bar" style="margin-top: 1.5rem;">
        <div class="search-input-wrapper">
          <font-awesome-icon :icon="['fas','magnifying-glass']" class="search-icon"/>
          <input
              type="text"
              v-model="threatsSearchTerm"
              placeholder="Search Threats..."
              class="search-input cardBackground"
              @input="goToBulkPage(1)"
          />
        </div>
<!--        <button class="filter-btn" @click="filterThreats">
          <font-awesome-icon :icon="['fas','filter']" />
        </button>-->
      </div>

      <!-- Rules list (paginated) -->
      <div class="list">
        <div
            v-for="threat in pagedBulk"
            :key="threat.name"
            class="list__item bulk-list__item"
        >
    <span class="blocked-list__domain">
      {{ threat.display_name }}
    </span>
          <button
              class="blocked-threat-checkbox"
              @click="toggleBlocked(threat)"
          >
            <font-awesome-icon
                :icon="[threat.enabled ? 'fas' : 'far', threat.enabled ? 'square-check' : 'square']"
            />
          </button>
        </div>
        <div v-if="filteredThreats.length === 0" class="no-results">
          No threats found
        </div>
      </div>

      <pagination-control
          :currentPage="currentBulkPage"
          :pageCount="bulkPageCount"
          :maxVisible="3"
          @update:currentPage="goToBulkPage"
      />
    </div>

    <!-- Adding Domain Modal -->
    <BaseModal
        :visible="visibleAddDomainModal"
        title="Add Domain"
        @close="closeAddDomainModal"
        @submit="saveDomain"
        submitLabel="Save"
        :cancelShow=false
    >
      <div class="text-box">
        <input
            type="text"
            class="fieldInput text-box-entry"
            v-model="newDomain"
            placeholder="Enter domain to block"
        />
      </div>
    </BaseModal>

    <!-- Adding IP Modal -->
    <BaseModal
        :visible="visibleAddIPModal"
        title="Add IP Address"
        @close="closeAddIPModal()"
        @submit="addIP()"
        submitLabel="Save"
        :cancelShow=false
    >

      <!-- Single IP or Network -->
      <div class="button-bar">
        <button
            v-for="opt in blockTypes"
            :key="opt.value"
            type="button"
            @click="isNetwork = opt.value"
            :class="['block-btn', { 'block-btn-active': isNetwork === opt.value }]"
            style="font-family: 'Poppins', 'Inter', sans-serif; font-size: 16px; font-weight: 300; padding: 0 .48rem;"
        >
          {{ opt.label }}
        </button>
      </div>

      <!-- IP input -->
      <div class="text-box-label" style="margin-top: .5rem;">
        IP Address:
      </div>
      <div class="text-box">
        <input
            type="text"
            class="fieldInput text-box-entry"
            v-model="newIP"
            placeholder="Enter IP to block"
        />
      </div>

      <!-- CIDR -->
      <div v-if="isNetwork">
        <div class="text-box-label" style="margin-top: .5rem;">
          CIDR:
        </div>
        <div class="text-box">
          <input
              type="text"
              class="fieldInput text-box-entry"
              v-model="newCIDR"
              placeholder="/32"
          />
        </div>
      </div>

      <!-- Description -->
      <div class="text-box-label" style="margin-top: .5rem;">
        Description (optional):
      </div>
      <div class="text-box">
        <input
            type="text"
            class="fieldInput text-box-entry"
            v-model="newIPDescrition"
            placeholder="Description"
        />
      </div>

    </BaseModal>

    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />
    <LoadingPage :is-visible="loading"/>
  </div>
</template>

<script>
import BannerComponent from '@/components/BannerComponent.vue'
import MessageModal from "@/components/MessageModal.vue";
import BaseModal from "@/components/BaseModal.vue";
import DeviceAPIService from "@/servicehandlers/DeviceAPIService";
import {useLoginStore} from "@/stores/loginStore";
import LoadingPage from "@/components/LoadingPage.vue";
import PaginationControl from "@/components/PaginationControl.vue";
const deviceAPIService = new DeviceAPIService()

export default {
  name: 'FilterBlockerPage',
  components: {LoadingPage, BaseModal, MessageModal, BannerComponent, PaginationControl},
  data(){
    return {
      appMessage: {
        text: '',
        type: 'error',
      },
      visibleAddDomainModal: false,
      visibleAddIPModal: false,
      blockedDomainsOpen: false,
      blockedIPsOpen: false,
      bulkBlockerOpen: false,
      newDomain: '',
      newIP: '',
      newCIDR: '',
      newIPDescrition: '',
      blockTypes: [
        { value: false, label: 'Single IP' },
        { value: true, label: 'Network' },
      ],
      isNetwork: false,
      blockedDomains: [],
      domainSearchTerm: '',
      currentDomainsPage: 1,
      itemsPerDomainsPage: 6,
      currentIPsPage: 1,
      itemsPerIPsPage: 6,
      currentBulkPage: 1,
      itemsPerBulkPage: 6,
      itemsPerBlockedDomainsPage: 8,
      blockedIPsSearchTerm: '',
      itemsPerBlockedIPsPage: 6,
      threatsSearchTerm: '',
      itemsPerThreatsPage: 6,
      blockedIPs: [],
      threats: [],
      // TODO: clean up quick blocks
      quickBlocks: [
        {prefix: "fab", icon: "youtube", domain: "youtube.com"},
        {prefix: "fab", icon: "facebook", domain: "facebook.com"},
        {prefix: "fab", icon: "instagram", domain: "instagram.com"},
        {prefix: "fab", icon: "tiktok", domain: "tiktok.com"}
      ],
      loading: false
    }
  },
  async mounted(){
    //console.clear()
    // Only 'device' users can access filter blocker functionality
    if (useLoginStore().getSubscriptionType === 'device') {
      if (useLoginStore().getDeviceOnline) {
        this.loading = true
        await this.getBlockedDomains()
        await this.getBlockedIps()
        await this.getBulkBlocks()
        this.loading = false
      } else {
        this.appMessage.text = "Device Offline"
        this.appMessage.type = 'info'
        this.$refs.messageModal.open()
      }
    }
    // 'free' users handled by route guards/subscription service
  },
  computed: {
    filteredDomains() {
      const term = this.domainSearchTerm.trim().toLowerCase();
      return term
          ? this.blockedDomains.filter(d => d.toLowerCase().includes(term))
          : this.blockedDomains;
    },
    // Blocked Domains
    domainsPageCount() {
      return Math.ceil(this.blockedDomains.length / this.itemsPerDomainsPage);
    },
    pagedDomains() {
      const start = (this.currentDomainsPage - 1) * this.itemsPerDomainsPage;
      return this.blockedDomains.slice(start, start + this.itemsPerDomainsPage);
    },
    visibleBlockedDomainsPages() {
      const pages = [];
      const lower = Math.max(1, this.currentBlockedDomainsPage - 1);
      const upper = Math.min(this.blockedDomainsPageCount, this.currentBlockedDomainsPage + 1);
      for (let p = lower; p <= upper; p++) {
        pages.push(p);
      }
      return pages;
    },
    filteredBlockedIPs() {
      const term = this.blockedIPsSearchTerm.trim().toLowerCase();
      return term
          ? this.blockedIPs.filter(item =>
              item.ip.toLowerCase().includes(term) ||
              (item.description || '').toLowerCase().includes(term)
          )
          : this.blockedIPs;
    },
    // Blocked IPs
    ipsPageCount() {
      return Math.ceil(this.blockedIPs.length / this.itemsPerIPsPage);
    },
    pagedIPs() {
      const start = (this.currentIPsPage - 1) * this.itemsPerIPsPage;
      return this.blockedIPs.slice(start, start + this.itemsPerIPsPage);
    },
    visibleBlockedIPsPages() {
      const pages = [];
      const lower = Math.max(1, this.currentBlockedIPsPage - 1);
      const upper = Math.min(this.blockedIPsPageCount, this.currentBlockedIPsPage + 1);
      for (let p = lower; p <= upper; p++) pages.push(p);
      return pages;
    },
    filteredThreats() {
      const term = this.threatsSearchTerm.trim().toLowerCase();
      return term
          ? this.threats.filter(threat => threat.display_name.toLowerCase().includes(term))
          : this.threats;
    },
    // Bulk Blocker
    bulkPageCount() {
      return Math.ceil(this.filteredThreats.length / this.itemsPerBulkPage);
    },
    pagedBulk() {
      const start = (this.currentBulkPage - 1) * this.itemsPerBulkPage;
      return this.filteredThreats.slice(start, start + this.itemsPerBulkPage);
    },
    visibleThreatsPages() {
      const pages = [];
      const lower = Math.max(1, this.currentThreatsPage - 1);
      const upper = Math.min(this.threatsPageCount, this.currentThreatsPage + 1);
      for (let p = lower; p <= upper; p++) pages.push(p);
      return pages;
    },
  },
  methods: {
    showUpgradeModal(featureName) {
      this.$router.push({
        name: 'upgrade',
        query: {
          feature: featureName,
          return: this.$route.path
        }
      })
    },
    showError(e){
      this.appMessage.text = 'Error: ' + e
      this.appMessage.type = 'error'
      this.$refs.messageModal.open()
    },
    async getBlockedDomains(){
      try {
        let response = await deviceAPIService.getBlockedSites(this.$router, useLoginStore())
        this.blockedDomains = response.domains;
      } catch (e) {
        this.showError(e)
      }
    },
    async getBlockedIps(){
      try {
        let response = await deviceAPIService.getBlockedIPs(this.$router, useLoginStore())
        this.blockedIPs = response.blocked_ips.map(data => {
          return {
            ip: data.ip,
            description: data.description
          };
        });
      } catch (e) {
        this.showError(e)
      }
    },
    async getBulkBlocks(){
      try {
        let response = await deviceAPIService.getBulkRules(this.$router, useLoginStore())
        console.log(response)
        this.threats = response.manifest.blocked_ips
      } catch (e) {
        this.showError(e)
      }
    },
    /**
     * Validate an IPv4 or IPv6 address (no CIDR).
     */
    isValidIP(addr) {
      const ipv4 = /^(25[0-5]|2[0-4]\d|[01]?\d?\d)(\.(25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/;
      const ipv6 = /^(([0-9A-Fa-f]{1,4}:){7}[0-9A-Fa-f]{1,4}|([0-9A-Fa-f]{1,4}:){1,7}:|([0-9A-Fa-f]{1,4}:){1,6}:[0-9A-Fa-f]{1,4}|([0-9A-Fa-f]{1,4}:){1,5}(:[0-9A-Fa-f]{1,4}){1,2}|([0-9A-Fa-f]{1,4}:){1,4}(:[0-9A-Fa-f]{1,4}){1,3}|([0-9A-Fa-f]{1,4}:){1,3}(:[0-9A-Fa-f]{1,4}){1,4}|([0-9A-Fa-f]{1,4}:){1,2}(:[0-9A-Fa-f]{1,4}){1,5}|[0-9A-Fa-f]{1,4}:((:[0-9A-Fa-f]{1,4}){1,6})|:((:[0-9A-Fa-f]{1,4}){1,7}|:))$/;
      return ipv4.test(addr) || ipv6.test(addr);
    },
    openModal(modalName) {
      this[modalName] = true
    },
    closeModal(modalName) {
      this[modalName] = false
    },
    toggleDropdown(bannerOption) {
      this[bannerOption] = !this[bannerOption];
    },
    openAddDomainModal() {
      this.openModal('visibleAddDomainModal');
    },
    closeAddDomainModal() {
      this.newDomain = "";
      this.closeModal('visibleAddDomainModal');
    },
    async saveDomain(){
      this.loading = true
      try{
        if (!this.blockedDomains.includes(this.newDomain)){
          await deviceAPIService.postBlockedSites({domain:this.newDomain}, this.$router, useLoginStore())
          this.newDomain = "";
          this.closeAddDomainModal();
          this.appMessage.text = 'Successfully added site!'
          this.appMessage.type = 'success'
          this.$refs.messageModal.open()
          await this.getBlockedDomains()
        } else {
          this.appMessage.text = this.newDomain + ' is already blocked.'
          this.appMessage.type = 'info'
          this.$refs.messageModal.open()
        }
        this.loading = false
      } catch (e) {
        this.showError(e)
        this.loading = false
      }
    },
    addQuickBlockDomain(domain){
      this.newDomain = domain
      this.saveDomain()
    },
    async removeDomain(domain) {
      this.loading = true
      try {
        await deviceAPIService.deleteBlockedSites({domain}, this.$router, useLoginStore())
        this.appMessage.text = 'Successfully removed site!'
        this.appMessage.type = 'success'
        this.$refs.messageModal.open()
        await this.getBlockedDomains()
        this.loading = false
      } catch (e) {
        this.showError(e)
        this.loading = false
      }
    },
    goToDomainsPage(page) {
      this.currentDomainsPage = Math.min(Math.max(page, 1), this.domainsPageCount);
    },
    goToIPsPage(page) {
      this.currentIPsPage = Math.min(Math.max(page, 1), this.ipsPageCount);
    },
    goToBulkPage(page) {
      this.currentBulkPage = Math.min(Math.max(page, 1), this.bulkPageCount);
    },
    filterDomains(){

    },
    filterIPs() {

    },
    filterThreats() {

    },
    openAddIPModal() {
      this.openModal('visibleAddIPModal')
    },
    closeAddIPModal() {
      this.newIP = '';
      this.newCIDR = '';
      this.isNetwork = false;
      this.newIPDescrition = '';
      this.closeModal('visibleAddIPModal')
    },
    async addIP() {
      this.loading = true
      try{
        // strip whitespace, validate raw IP
        const rawIP = this.newIP.trim();
        if (!this.isValidIP(rawIP)) {
          this.appMessage.text = 'Please enter a valid IPv4 or IPv6 address.';
          this.appMessage.type = 'error';
          this.$refs.messageModal.open();
          this.loading = false;
          return;
        }
        if (this.newCIDR === ""){
          this.newCIDR = "/32";
        }
        const IP = this.newIP + this.newCIDR
        if (!this.blockedIPs.some(data => data.id === IP)){
          await deviceAPIService.postBlockedIPs({ip: IP, description: this.newIPDescrition}, this.$router, useLoginStore())
          this.newIP = ''
          this.newCIDR = ''
          this.newIPDescrition = "";
          this.closeAddIPModal();
          this.appMessage.text = 'Successfully blocked ip!'
          this.appMessage.type = 'success'
          this.$refs.messageModal.open()
          await this.getBlockedIps()
          this.loading = false
        } else {
          this.appMessage.text = this.newIP + ' is already blocked.'
          this.appMessage.type = 'info'
          this.$refs.messageModal.open()
          this.loading = false
        }
      } catch (e) {
        this.showError(e)
      }
    },
    async removeIP(address) {
      this.loading = true
      try {
        await deviceAPIService.deleteBlockedIPs({ip: address.ip}, this.$router, useLoginStore())
        this.appMessage.text = 'Successfully removed ip!'
        this.appMessage.type = 'success'
        this.$refs.messageModal.open()
        await this.getBlockedIps()
        this.loading = false
      } catch (e) {
        this.showError(e)
        this.loading = false
      }
    },
    async toggleBlocked(threat) {
      this.loading = true
      threat.enabled = !threat.enabled;
      try{
        if (threat.enabled){
          await deviceAPIService.postBulkRules({list: threat.name, status: 'enabled'})
          this.appMessage.text = "Successfully enabled " + threat.name + ' blocker!'
          this.appMessage.type = 'success'
          this.$refs.messageModal.open()
        } else {
          await deviceAPIService.deleteBulkRules({list: threat.name, status: 'disabled'})
          this.appMessage.text = "Successfully enabled " + threat.name + ' blocker!'
          this.appMessage.type = 'success'
          this.$refs.messageModal.open()
        }
        this.loading = false
      } catch (e) {
        this.showError(e)
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>

.bulk-list__item {
  display: flex;
  align-items: center;
  justify-content: space-between; /* name on left, button on right */
}

.blocked-list__domain {
  flex: 1;           /* take up all available space */
  text-align: left;  /* force its text flush left */
}

.blocked-threat-checkbox {
  flex-shrink: 0;    /* keep button at its natural size */
}

.banner h2 {
  margin-top: 0.375rem;
}

hr {
  border: none;
  border-top: 1px solid var(--color-modal-divider);
  margin: 0.375rem 0;
}

.quick-block {
  padding: 0 1rem;
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.body {
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  color: var(--text-primary);
  text-align: left;
}

.quick-block__items {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
}

.quick-block__btn {
  background-color: var(--color-card);
  border-radius: 0.5rem;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.quick-block__btn svg {
  font-size: 1.9rem;
  color: var(--text-primary)
}

.blocked-list__domain {
  color: var(--text-primary);
  font-size: 1.2rem;
}

.blocked-list__remove-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--error-red);
}

.blocked-list__remove-btn svg {
  width: 1.25em;
  height: 1.25em;
}

.banner-heading {
  display: inline-block;
  margin-left: 0.5rem;
  font-size: 1.125rem;
  color: var(--text-primary);
}

.filterButtons {
  display: flex;
  justify-content: left;
  margin-left: 1rem;
  margin-top: 1.5rem;
}

.blocked-threat-checkbox {
  /* remove any default button outline/border */
  border: none;
  background: transparent;
  color: var(--color-primary-button);
  font-size: 1.35rem;
}

.button-bar {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 0.75rem;
}

/* base style for each toggle button */
.block-btn {
  padding: 0.4rem 0.75rem;
  border: 1px solid var(--color-secondary-button);
  background-color: transparent;
  color: var(--text-primary);
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s, color 0.2s;
}

.block-btn:hover {
  opacity: 0.85;
}

/* when selected, show solid primary‐blue background and white text */
.block-btn-active {
  background-color: var(--color-secondary-button);
  color: var(--text-primary);
  border-color: var(--color-secondary-button-border);
}


</style>
